var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecreaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0862 20.3221L22.4433 14.9864C22.4219 14.8096 22.205 14.7346 22.0791 14.8605L20.4907 16.4515L13.2237 9.18725C13.055 9.02118 12.7844 9.02118 12.6183 9.18725L9.89156 11.9114L2.47995 4.49975C2.43968 4.45987 2.38529 4.4375 2.32861 4.4375C2.27194 4.4375 2.21755 4.45987 2.17728 4.49975L0.971918 5.71046C0.932039 5.75074 0.909668 5.80513 0.909668 5.8618C0.909668 5.91848 0.932039 5.97287 0.971918 6.01314L9.58888 14.6355C9.75495 14.8042 10.0282 14.8042 10.1942 14.6355L12.921 11.9114L18.9773 17.9649L17.3889 19.5533C17.3606 19.5818 17.3408 19.6176 17.3318 19.6568C17.3229 19.6959 17.3251 19.7368 17.3382 19.7747C17.3513 19.8127 17.3748 19.8462 17.406 19.8715C17.4372 19.8967 17.4749 19.9127 17.5148 19.9176L22.8505 20.5605C22.9871 20.5792 23.105 20.4614 23.0862 20.3221Z",
    fill: "#58B947"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseIcon);
export default __webpack_public_path__ + "static/media/decrease-icon.55bd0b042829fc7e91cf528c2a866e1c.svg";
export { ForwardRef as ReactComponent };